import * as types from 'mutation-types'
import model from 'api'

const state = {
  port: '',
  clientList: [],
  current: {},

  commonDialog: false,
  freqDialog: false,
  restartDialog: false,

  loading: false
}

const getters = {}

const mutations = {
  [types.MWS_SET_SERVER] (state, { port, list }) {
    state.port = port
    state.clientList = list
  },
  [types.MWS_TOGGLE_COMMON_DIALOG] (state, { current, visible }) {
    state.current = current
    state.commonDialog = visible
  },
  [types.MWS_TOGGLE_FREQ_DIALOG] (state, { current, visible }) {
    state.current = current
    state.freqDialog = visible
  },
  [types.MWS_TOGGLE_RESTART_DIALOG] (state, { current, visible }) {
    state.current = current
    state.restartDialog = visible
  },

  [types.MWS_SET_LOADING] (state, loading) {
    state.loading = loading
  }
}

const actions = {
  async getServerData ({ commit }) {
    try {
      commit(types.MWS_SET_LOADING, true)
      const { port, list } = await model.Mws.getServerData()
      commit(types.MWS_SET_SERVER, { port, list })
    } catch (e) {
      commit(types.MWS_SET_SERVER, { port: '', list: [] })
    } finally {
      commit(types.MWS_SET_LOADING, false)
    }
  },
  async destroyClient ({ commit, dispatch }, { imei = 'idle' } = {}) {
    await model.Mws.destroyClient(imei)
    await dispatch('getServerData')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
